import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-path-right"><path d="M15.0528 4.36309C14.2392 3.68147 13 4.25989 13 5.32124V8.00002H5.75C3.67893 8.00002 2 9.67896 2 11.75V12.25C2 14.3211 3.67893 16 5.75 16H13V18.6788C13 19.7402 14.2392 20.3186 15.0528 19.637L22.1093 13.7247C23.1827 12.8254 23.1827 11.1746 22.1093 10.2754L15.0528 4.36309Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowPathRight;
